// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IAggregatorManualContributionRecordDto } from './IAggregatorManualContributionRecordDto';
import {
    IAggregatorManualContributionRecordDtoFromJSON,
    IAggregatorManualContributionRecordDtoFromJSONTyped,
    IAggregatorManualContributionRecordDtoToJSON,
    IAggregatorManualContributionRecordDtoToJSONTyped,
} from './IAggregatorManualContributionRecordDto';
import type { IEmployeeIdPlanCodePairDto } from './IEmployeeIdPlanCodePairDto';
import {
    IEmployeeIdPlanCodePairDtoFromJSON,
    IEmployeeIdPlanCodePairDtoFromJSONTyped,
    IEmployeeIdPlanCodePairDtoToJSON,
    IEmployeeIdPlanCodePairDtoToJSONTyped,
} from './IEmployeeIdPlanCodePairDto';
import type { IContributionSegmentDto } from './IContributionSegmentDto';
import {
    IContributionSegmentDtoFromJSON,
    IContributionSegmentDtoFromJSONTyped,
    IContributionSegmentDtoToJSON,
    IContributionSegmentDtoToJSONTyped,
} from './IContributionSegmentDto';

/**
 * 
 * @export
 * @interface IAggregatorManualContributionRequestDto
 */
export interface IAggregatorManualContributionRequestDto {
    /**
     * 
     * @type {IContributionSegmentDto}
     * @memberof IAggregatorManualContributionRequestDto
     */
    contribution_segment_dto: IContributionSegmentDto;
    /**
     * 
     * @type {Array<IAggregatorManualContributionRecordDto>}
     * @memberof IAggregatorManualContributionRequestDto
     */
    manual_contribution_record_dtos: Array<IAggregatorManualContributionRecordDto>;
    /**
     * 
     * @type {string}
     * @memberof IAggregatorManualContributionRequestDto
     */
    audit_action: IAggregatorManualContributionRequestDtoAuditActionEnum;
    /**
     * 
     * @type {Set<IEmployeeIdPlanCodePairDto>}
     * @memberof IAggregatorManualContributionRequestDto
     */
    excluded_accounts?: Set<IEmployeeIdPlanCodePairDto>;
}

/**
* @export
* @enum {string}
*/
export enum IAggregatorManualContributionRequestDtoAuditActionEnum {
    CREATE = 'CREATE',
    CREATE_FROM_TEMPLATE = 'CREATE_FROM_TEMPLATE',
    UPDATE = 'UPDATE',
    BULK_UPDATE = 'BULK_UPDATE'
}


/**
 * Check if a given object implements the IAggregatorManualContributionRequestDto interface.
 */
export function instanceOfIAggregatorManualContributionRequestDto(value: object): value is IAggregatorManualContributionRequestDto {
    if (!('contribution_segment_dto' in value) || value['contribution_segment_dto'] === undefined) return false;
    if (!('manual_contribution_record_dtos' in value) || value['manual_contribution_record_dtos'] === undefined) return false;
    if (!('audit_action' in value) || value['audit_action'] === undefined) return false;
    return true;
}

export function IAggregatorManualContributionRequestDtoFromJSON(json: any): IAggregatorManualContributionRequestDto {
    return IAggregatorManualContributionRequestDtoFromJSONTyped(json, false);
}

export function IAggregatorManualContributionRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAggregatorManualContributionRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'contribution_segment_dto': IContributionSegmentDtoFromJSON(json['contribution_segment_dto']),
        'manual_contribution_record_dtos': ((json['manual_contribution_record_dtos'] as Array<any>).map(IAggregatorManualContributionRecordDtoFromJSON)),
        'audit_action': json['audit_action'],
        'excluded_accounts': json['excluded_accounts'] == null ? undefined : (new Set((json['excluded_accounts'] as Array<any>).map(IEmployeeIdPlanCodePairDtoFromJSON))),
    };
}

export function IAggregatorManualContributionRequestDtoToJSON(json: any): IAggregatorManualContributionRequestDto {
    return IAggregatorManualContributionRequestDtoToJSONTyped(json, false);
}

export function IAggregatorManualContributionRequestDtoToJSONTyped(value?: IAggregatorManualContributionRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'contribution_segment_dto': IContributionSegmentDtoToJSON(value['contribution_segment_dto']),
        'manual_contribution_record_dtos': ((value['manual_contribution_record_dtos'] as Array<any>).map(IAggregatorManualContributionRecordDtoToJSON)),
        'audit_action': value['audit_action'],
        'excluded_accounts': value['excluded_accounts'] == null ? undefined : (Array.from(value['excluded_accounts'] as Set<any>).map(IEmployeeIdPlanCodePairDtoToJSON)),
    };
}

